import { render, staticRenderFns } from "./shipping_info.vue?vue&type=template&id=a2c7c69e&scoped=true&"
import script from "./shipping_info.vue?vue&type=script&lang=js&"
export * from "./shipping_info.vue?vue&type=script&lang=js&"
import style0 from "./shipping_info.vue?vue&type=style&index=0&id=a2c7c69e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c7c69e",
  null
  
)

export default component.exports